export var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-transition-group/esm/utils/reflow.js
// module id = ./node_modules/react-transition-group/esm/utils/reflow.js
// module chunks = 1